import qs from "qs";
import { ILateCharge } from "../../types/LateCharges";
import authAxios, { authHeader } from "../data";

const fetch = async (id: string) => {
  const response = await authAxios.get("/api/ContractLateCharges/" + id, {
    headers: authHeader(),
  });

  return response.data;
};

const fetchAll = async (req: any) => {
  const response = await authAxios.get("/api/ContractLateCharges", {
    params: req,
    paramsSerializer: (params) => qs.stringify(params),
    headers: authHeader(),
  });

  return response.data;
};

const fetchCount = async (req: any) => {
  const response = await authAxios.get("/api/ContractLateCharges/Count", {
    params: req,
    paramsSerializer: (params) => qs.stringify(params),
    headers: authHeader(),
  });

  return response.data;
};

const create = async (req: ILateCharge) => {
  const response = await authAxios.post("/api/ContractLateCharges", req, {
    headers: authHeader(),
  });

  return response.data;
};

const edit = async (req: ILateCharge, id: string) => {
  const response = await authAxios.put("/api/ContractLateCharges/" + id, req, {
    headers: authHeader(),
  });

  return response.data;
};

const remove = async (id: string) => {
  const response = await authAxios.delete("/api/ContractLateCharges/" + id, {
    headers: authHeader(),
  });

  return response.data;
};

const fetchTotal = async (contractId: string) => {
  const response = await authAxios.get(
    "/api/ContractLateCharges/total?contractId=" + contractId,
    {
      headers: authHeader(),
    }
  );

  return response.data;
};

const updateTotal = async (req: any, id: string) => {
  const response = await authAxios.put(
    "/api/ContractLateCharges/total?contractId=" + id,
    req,
    {
      headers: authHeader(),
    }
  );

  return response.data;
};

const ContractLateChargesService = {
  fetch,
  fetchAll,
  fetchCount,
  create,
  edit,
  remove,
  fetchTotal,
  updateTotal,
};

export default ContractLateChargesService;
